module.exports = __webpack_public_path__ + "img/PS45.604dfec0.png";